var map = {
	"./CVAG/config.json": 81,
	"./CVAG/i18n/de.json": 214,
	"./CVAG/i18n/en.json": 215,
	"./CVAG/i18n/languages.json": 216,
	"./VRB/config.json": 82,
	"./VRB/i18n/de.json": 217,
	"./VRB/i18n/en.json": 218,
	"./VRB/i18n/languages.json": 219
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 213;